import { render, staticRenderFns } from "./SaasPlatform.vue?vue&type=template&id=e90d7342&scoped=true"
import script from "./SaasPlatform.vue?vue&type=script&lang=js"
export * from "./SaasPlatform.vue?vue&type=script&lang=js"
import style0 from "./SaasPlatform.vue?vue&type=style&index=0&id=e90d7342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90d7342",
  null
  
)

export default component.exports